import {
    ADD_MEMBER,
    ADD_MEMBER_SUCCESS,
    ADD_MEMBER_FAILURE,
    RESET_MEMBER_CREATION_STATE,
    IMPORT_MEMBERS,
    IMPORT_MEMBERS_SUCCESS,
    IMPORT_MEMBERS_FAILURE,
    RESET_MEMBER_IMPORT_STATE,
    SET_INVITE_PENDING_MEMBERS,
    RESET_INVITE_PENDING_MEMBERS,
    ADD_INVITE_PENDING_MEMBERS,
    ADD_INVITE_PENDING_MEMBERS_SUCCESS,
    ADD_INVITE_PENDING_MEMBERS_FAILURE,
    GET_INVITED_MEMBERS_FOR_ORG,
    GET_INVITED_MEMBERS_FOR_ORG_SUCCESS,
    GET_INVITED_MEMBERS_FOR_ORG_FAILURE,
    GET_COMMUNITY_MEMBERS_FOR_ORG,
    GET_COMMUNITY_MEMBERS_FOR_ORG_SUCCESS,
    GET_COMMUNITY_MEMBERS_FOR_ORG_FAILURE,
    GET_ASSOCIATE_MEMBERS_FOR_ORG_SUCCESS,
    GET_ASSOCIATE_MEMBERS_FOR_ORG_FAILURE,
    GET_ORG_GUESTS_FOR_ORG_SUCCESS,
    GET_ORG_GUESTS_FOR_ORG_FAILURE,
    UPDATE_USER_AVATAR,
    UPDATE_USER_AVATAR_SUCCESS,
    UPDATE_USER_AVATAR_FAILURE,
    UPDATE_USER_PROFILE_INFO,
    UPDATE_USER_PROFILE_INFO_SUCCESS,
    UPDATE_USER_PROFILE_INFO_FAILURE,
    UPDATE_USER_PROFILE_INFO_RESET,
    SET_ACTIVE_USER_ORG,
    SET_PAGE_INDEX,
    SET_ROW_COUNT,
    DOWNLOAD_CSV_TEMPLATE,
    DOWNLOAD_CSV_TEMPLATE_SUCCESS,
    DOWNLOAD_CSV_TEMPLATE_FAILURE,
    ADVANCE_MEMBER_QUERY,
    ADVANCE_MEMBER_QUERY_SUCCESS,
    ADVANCE_MEMBER_QUERY_FAILURE,
    STORE_UNASSIGNED_DEVICES,
    GET_ORG_INVITES_V2_FAILURE,
    GET_ORG_INVITES_V2_SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
    addingMember: false,
    orgInvitesV2: null,
    orgInviteMembers: null,
    orgInviteOperators: null,
    orgInviteGuests: null,
    csvTemplateUrl: null,
    csvError: null,
    memberCreationError: null,
    addedMemberEmail: null,
    importingMembers: false,
    importMembersSuccess: false,
    importMembersError: null,
    unassignedDevices: [],
    invitePendingMembers: null,
    addingInvitePendingMembers: false,
    addingInvitePendingMembersError: null,
    addingInvitePendingMembersSuccess: false,
    invitedMembers: null,
    loadingInvitedMembers: false,
    invitedMembersLoadError: null,
    communityMembers: null,
    membersByProperty: null,
    loadingCommunityMembers: false,
    communityMembersLoadError: null,
    associateMembers: null,
    associateMembersLoadError: null,
    orgGuests: null,
    guestsCount: 0,
    orgGuestsLoadError: null,
    uploadingAvatar: false,
    uploadAvatarSuccess: false,
    uploadAvatarError: null,
    updatingAccountInfo: false,
    updatingAccountInfoSuccess: false,
    updatingAccountInfoError: null,
    importPage: 0,
    importRow: 10,
    invitePage: 0,
    inviteRow: 10,
    membersPage: 0,
    membersRow: 10,
    membersCount: 0,
    loadingMemberQuery: false,
    memberQueryError: null,
    queryMembers: null
};

const managerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_MEMBER:
            return {
                ...state,
                addingMember: true,
                addedMemberEmail: null
            };
        case ADD_MEMBER_SUCCESS:
            return {
                ...state,
                addingMember: false,
                addedMemberEmail: action.payload
            };
        case ADD_MEMBER_FAILURE:
            return {
                ...state,
                addingMember: false,
                memberCreationError: action.payload
            };
        case RESET_MEMBER_CREATION_STATE:
            return {
                ...state,
                addingMember: false,
                memberCreationError: null,
                addedMemberEmail: null
            };
        case IMPORT_MEMBERS:
            return {
                ...state,
                importingMembers: true,
                importMembersSuccess: false,
                importMembersError: null
            };

        case IMPORT_MEMBERS_SUCCESS:
            return {
                ...state,
                importingMembers: false,
                importMembersSuccess: action.payload,
                importMembersError: null
            };
        case IMPORT_MEMBERS_FAILURE:
            return {
                ...state,
                importingMembers: false,
                importMembersSuccess: false,
                importMembersError: action.payload
            };
        case RESET_MEMBER_IMPORT_STATE:
            return {
                ...state,
                importingMembers: false,
                importMembersSuccess: false,
                importMembersError: null
            };
        case SET_INVITE_PENDING_MEMBERS:
            return {
                ...state,
                invitePendingMembers: action.payload
            };
        case RESET_INVITE_PENDING_MEMBERS:
            return {
                ...state,
                invitePendingMembers: null
            };
        case ADD_INVITE_PENDING_MEMBERS:
            return {
                ...state,
                addingInvitePendingMembers: true,
                addingInvitePendingMembersError: null,
                addingInvitePendingMembersSuccess: false
            };
        case ADD_INVITE_PENDING_MEMBERS_SUCCESS:
            return {
                ...state,
                addingInvitePendingMembers: false,
                addingInvitePendingMembersError: null,
                addingInvitePendingMembersSuccess: true
            };
        case ADD_INVITE_PENDING_MEMBERS_FAILURE:
            return {
                ...state,
                addingInvitePendingMembers: false,
                addingInvitePendingMembersError: action.payload,
                addingInvitePendingMembersSuccess: false
            };
        case GET_INVITED_MEMBERS_FOR_ORG:
            return {
                ...state,
                invitedMembers: null,
                loadingInvitedMembers: true,
                invitedMembersLoadError: null
            };
        case GET_INVITED_MEMBERS_FOR_ORG_SUCCESS:
            return {
                ...state,
                invitedMembers: action.payload,
                loadingInvitedMembers: false,
                invitedMembersLoadError: null
            };
        case GET_INVITED_MEMBERS_FOR_ORG_FAILURE:
            return {
                ...state,
                invitedMembers: null,
                loadingInvitedMembers: false,
                invitedMembersLoadError: action.payload
            };
        case GET_COMMUNITY_MEMBERS_FOR_ORG:
            return {
                ...state,
                communityMembers: null,
                membersByProperty: null,
                membersCount: 0,
                loadingCommunityMembers: true,
                communityMembersLoadError: null
            };
        case GET_COMMUNITY_MEMBERS_FOR_ORG_SUCCESS:
            return {
                ...state,
                communityMembers: action.payload.members,
                membersByProperty: action.payload.membersByProperty,
                membersCount: action.payload.membersCount,
                loadingCommunityMembers: false,
                communityMembersLoadError: null
            };
        case GET_COMMUNITY_MEMBERS_FOR_ORG_FAILURE:
            return {
                ...state,
                communityMembers: null,
                membersByProperty: null,
                membersCount: 0,
                loadingCommunityMembers: false,
                communityMembersLoadError: action.payload
            };
        case GET_ASSOCIATE_MEMBERS_FOR_ORG_SUCCESS:
            return {
                ...state,
                associateMembers: action.payload,
                associateMembersLoadError: null
            };
        case GET_ASSOCIATE_MEMBERS_FOR_ORG_FAILURE:
            return {
                ...state,
                associateMembers: null,
                associateMembersLoadError: action.payload
            };
        case GET_ORG_GUESTS_FOR_ORG_SUCCESS:
            return {
                ...state,
                orgGuests: action.payload.guests,
                guestsCount: action.payload.guestsCount,
                orgGuestsLoadError: null
            };
        case GET_ORG_GUESTS_FOR_ORG_FAILURE:
            return {
                ...state,
                orgGuests: null,
                guestsCount: 0,
                orgGuestsLoadError: action.payload
            };
        case UPDATE_USER_AVATAR:
            return {
                ...state,
                uploadingAvatar: true,
                uploadAvatarSuccess: false,
                uploadAvatarError: null
            };
        case UPDATE_USER_AVATAR_SUCCESS:
            return {
                ...state,
                uploadingAvatar: false,
                uploadAvatarSuccess: action.payload,
                uploadAvatarError: null
            };
        case UPDATE_USER_AVATAR_FAILURE:
            return {
                ...state,
                uploadingAvatar: false,
                uploadAvatarSuccess: false,
                uploadAvatarError: action.payload
            };
        case UPDATE_USER_PROFILE_INFO:
            return {
                ...state,
                updatingAccountInfo: true,
                updatingAccountInfoSuccess: false,
                updatingAccountInfoError: null
            };
        case UPDATE_USER_PROFILE_INFO_SUCCESS:
            return {
                ...state,
                updatingAccountInfo: false,
                updatingAccountInfoSuccess: true,
                updatingAccountInfoError: null
            };
        case UPDATE_USER_PROFILE_INFO_FAILURE:
            return {
                ...state,
                updatingAccountInfo: false,
                updatingAccountInfoSuccess: false,
                updatingAccountInfoError: action.payload
            };
        case UPDATE_USER_PROFILE_INFO_RESET:
            return {
                ...state,
                updatingAccountInfo: false,
                updatingAccountInfoSuccess: false,
                updatingAccountInfoError: null
            };
        case SET_ACTIVE_USER_ORG:
            return {
                ...state,
                orgInvitesV2: null,
                orgInviteMembers: null,
                orgInviteOperators: null,
                orgInviteGuests: null,
                invitedMembers: [],
                importPage: INITIAL_STATE.importPage,
                importRow: INITIAL_STATE.importRow,
                invitePage: INITIAL_STATE.invitePage,
                inviteRow: INITIAL_STATE.inviteRow,
                membersPage: INITIAL_STATE.membersPage,
                membersRow: INITIAL_STATE.membersRow
            };
        case SET_PAGE_INDEX:
            return {
                ...state,
                importPage:
                    action.payload.type === 'import'
                        ? action.payload.value
                        : state.importPage,
                invitePage:
                    action.payload.type === 'invite'
                        ? action.payload.value
                        : state.invitePage,
                membersPage:
                    action.payload.type === 'members'
                        ? action.payload.value
                        : state.membersPage
            };
        case SET_ROW_COUNT:
            return {
                ...state,
                importRow:
                    action.payload.type === 'import'
                        ? action.payload.value
                        : state.importRow,
                inviteRow:
                    action.payload.type === 'invite'
                        ? action.payload.value
                        : state.inviteRow,
                membersRow:
                    action.payload.type === 'members'
                        ? action.payload.value
                        : state.membersRow
            };
        case DOWNLOAD_CSV_TEMPLATE:
            return { ...state, csvTemplateUrl: null, csvError: null };
        case DOWNLOAD_CSV_TEMPLATE_SUCCESS:
            return { ...state, csvTemplateUrl: action.payload, csvError: null };
        case DOWNLOAD_CSV_TEMPLATE_FAILURE:
            return { ...state, csvTemplateUrl: null, csvError: action.payload };
        case ADVANCE_MEMBER_QUERY:
            return {
                ...state,
                loadingMemberQuery: true,
                memberQueryError: null,
                queryMembers: null
            };
        case ADVANCE_MEMBER_QUERY_SUCCESS:
            return {
                ...state,
                loadingMemberQuery: false,
                memberQueryError: null,
                queryMembers: action.payload
            };
        case ADVANCE_MEMBER_QUERY_FAILURE:
            return {
                ...state,
                loadingMemberQuery: false,
                memberQueryError: action.payload,
                queryMembers: null
            };
        case STORE_UNASSIGNED_DEVICES:
            return {
                ...state,
                unassignedDevices: action.payload
            };
        case GET_ORG_INVITES_V2_SUCCESS:
            return {
                ...state,
                orgInvitesV2: action.payload.all,
                orgInviteMembers: action.payload.members,
                orgInviteOperators: action.payload.operators,
                orgInviteGuests: action.payload.guests
            };
        case GET_ORG_INVITES_V2_FAILURE:
            return {
                ...state,
                orgInvitesV2: null,
                orgInviteMembers: null,
                orgInviteOperators: null,
                orgInviteGuests: null
            };
        default:
            return state;
    }
};

export default managerReducer;
